
import React, { useEffect, useState } from 'react'
import { FaTimes } from "react-icons/fa";
import { getOnesubscription } from '../services/transactionServices';
import { useSelector } from 'react-redux';
export default function TransactionInfoModal({ isOpen, closeModal, modalData }) {
    const [planData, setPlanData] = useState([])
    const accessToken = useSelector((state) => state.auth.accessToken);


    useEffect(() => {
        if (!isOpen || !modalData?.subId) return;

        const subInfo = async () => {
            const res = await getOnesubscription({ accessToken, id: modalData.subId });
            if (res?.ok) {
                setPlanData(res?.data);
            }
        };
        subInfo();
    }, [accessToken, isOpen, modalData?.subId]);
    if (!modalData) return null;
    return (
        <div className={`fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50 ${isOpen ? "block" : "hidden"}`}>
            <div className=" p-6 rounded-lg max-w-[500px] w-full  bg-white divide-y divide-gray-600">
                <div className="flex justify-between items-center ">
                    <h3 className="text-xl font-bold text-[#1B4748]">اطلاعات پرداختی بات {modalData.business.username}</h3>
                    <button onClick={closeModal} className="text-red-500">
                        <FaTimes className="text-xl" />
                    </button>
                </div>

                <div className="mt-4 ">
                    <p className='mb-2 mt-2'><strong>کد تراکنش :</strong>  {modalData?.id || '---'}</p>
                    {modalData?.refId && <p className='mb-2 '><strong>کد پیگیری:</strong> {modalData?.refId || '---'}</p>}
                    {modalData?.cardNumber && <p className='mb-2 '><strong>شماره کارت :</strong> <span className="inline-block text-left ltr"
                        style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}>{modalData?.cardNumber || '---'}</span></p>}
                    {planData?.plan?.name && <p className='mb-2 '><strong> نام طرح خریداری شده :</strong> {planData?.plan?.name || '---'}</p>}
                </div>
            </div>
        </div>
    );

}
